// @ts-nocheck

/**
 * * `STORY_GENERATION` - Story Generation
 * `IMAGE_GENERATION` - Image Generation
 * `SLIDE_REGENERATION` - Slide Regeneration
 * `CHARACTER_CREATION` - Character Creation
 */
export type ActionTypeEnum = typeof ActionTypeEnum[keyof typeof ActionTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionTypeEnum = {
  STORY_GENERATION: "STORY_GENERATION",
  IMAGE_GENERATION: "IMAGE_GENERATION",
  SLIDE_REGENERATION: "SLIDE_REGENERATION",
  CHARACTER_CREATION: "CHARACTER_CREATION",
} as const;
